var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rating-wrapper" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.capterra.com/p/204342/IdeaBuddy/reviews/",
            target: "_blank",
            rel: "noreferrer",
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/pricing/lifetime-deal/rating-capterra.webp"),
              alt: "rating-capterra",
            },
          }),
        ]
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.forbes.com/advisor/business/software/best-business-plan-software/",
            target: "_blank",
            rel: "noreferrer",
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/pricing/lifetime-deal/rating-forbes.webp"),
              alt: "rating-forbes",
            },
          }),
        ]
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.g2.com/products/ideabuddy/reviews",
            target: "_blank",
            rel: "noreferrer",
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/pricing/lifetime-deal/rating-g2.webp"),
              alt: "rating-g2",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }